/* Floodlight · ss-cart.js (core) — AJAX cart, Section Rendering, drawer, flight, badge, quick add, product forms */
(function () {
  'use strict';
  if (window.SS_LOADED_cart) return;
  window.SS_LOADED_cart = true;
  var SS = window.SS;
  if (!SS) return;
  var doc = document, C = SS.config || {}, R = C.routes || {};
  var DR = 'ss-drawer', root = (R.root || '/').replace(/\/?$/, '/');
  var addUrl = (R.cartAdd || root + 'cart/add') + '.js';
  var changeUrl = (R.cartChange || root + 'cart/change') + '.js';
  var cartJs = R.cartJs || root + 'cart.js';
  var busy = 0, pend = {};

  function drawer() { return doc.getElementById(DR); }
  function ids() {
    var list = ['cart-drawer', 'cart-count'];
    SS.qsa('[data-cart-section]').forEach(function (el) {
      var id = el.getAttribute('data-cart-section');
      if (id && list.indexOf(id) < 0 && list.length < 5) list.push(id);
    });
    return list;
  }
  function parse(s) { return new DOMParser().parseFromString(s || '', 'text/html'); }
  function syncBody() {
    var b = SS.qs('#' + DR + ' .drawer-body');
    if (b) b.classList.toggle('scrollable', b.scrollHeight > b.clientHeight + 4);
  }

  /* keep focus on the same stepper control across re-renders; when that control is gone, fall back to
     the next line's control, then the drawer close button / the cart section's heading, never <body> */
  function memo() {
    var a = doc.activeElement;
    if (!a || a === doc.body || !a.closest) return null;
    var dr = drawer(), inDr = !!(dr && dr.contains(a)), sec = a.closest('[data-cart-section]');
    var m = { key: '', sel: '', dr: inDr, sec: sec ? sec.getAttribute('data-cart-section') : '' };
    var box = a.closest('[data-line-key]');
    if (box) {
      m.key = box.getAttribute('data-line-key');
      m.sel = a.classList.contains('qty-in') ? '.qty-in' : a.hasAttribute('data-qty-step') ? '[data-qty-step="' + a.getAttribute('data-qty-step') + '"]' : '';
    }
    return (m.dr || m.sec || m.key) ? m : null;
  }
  function recall(m) {
    if (!m) return;
    var now = doc.activeElement;
    if (now && now !== doc.body && doc.contains(now)) return; /* focus survived the re-render */
    var scope = m.dr ? drawer() : (m.sec ? doc.querySelector('[data-cart-section="' + m.sec + '"]') : doc), t = null;
    if (!scope) return;
    var boxes = SS.qsa('[data-qty][data-line-key]', scope);
    if (m.sel) boxes.some(function (b) { return b.getAttribute('data-line-key') === m.key && (t = b.querySelector(m.sel)); });
    if (!t && m.key && boxes.length) t = boxes[0].querySelector(m.sel || '.qty-in');
    if (!t && m.dr) t = scope.querySelector('.drawer-head button');
    if (!t) t = scope.querySelector('[data-cart-focus]') || scope.querySelector('a[href], button:not([disabled])');
    try { if (t) t.focus({ preventScroll: true }); } catch (e) {}
  }

  function apply(sections) {
    if (!sections) return;
    var m = memo(), dr = drawer();
    if (sections['cart-drawer'] && dr) {
      var nd = parse(sections['cart-drawer']).getElementById(DR);
      if (nd) {
        if (dr.hidden) dr.removeAttribute('data-still'); else dr.setAttribute('data-still', '');
        dr.innerHTML = nd.innerHTML;
        dr.setAttribute('data-item-count', nd.getAttribute('data-item-count') || '0');
      }
    }
    if (sections['cart-count']) {
      var inner = parse(sections['cart-count']).querySelector('[data-cart-count-inner]');
      if (inner) {
        SS.qsa('[data-cart-count]').forEach(function (w) { w.innerHTML = inner.outerHTML; });
        SS.qsa('[data-cart-label]').forEach(function (s) { s.textContent = inner.getAttribute('data-label') || ''; });
        SS.qsa('[data-cart-aria]').forEach(function (s) { s.setAttribute('aria-label', inner.getAttribute('data-aria') || ''); });
      }
    }
    Object.keys(sections).forEach(function (id) {
      if (id === 'cart-drawer' || id === 'cart-count' || !sections[id]) return;
      var sel = '[data-cart-section="' + id + '"]', fresh = parse(sections[id]).querySelector(sel);
      if (fresh) SS.qsa(sel).forEach(function (el) { el.innerHTML = fresh.innerHTML; });
    });
    syncBody();
    recall(m);
    if (SS.scanReveals) SS.scanReveals();
  }

  function flash(vid, focusRow) {
    var dr = drawer(), row = vid && dr && dr.querySelector('[data-line-variant="' + vid + '"]');
    if (!row) return;
    if (focusRow && !dr.hidden) { var q = row.querySelector('.qty-in'); try { if (q) q.focus({ preventScroll: true }); } catch (e) {} }
    try { row.scrollIntoView({ behavior: SS.reduced ? 'auto' : 'smooth', block: 'nearest' }); } catch (e) {}
    row.classList.remove('flash'); void row.offsetWidth; row.classList.add('flash');
  }
  function bump() {
    var c = doc.getElementById('ss-count');
    if (c) { c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); }
  }
  /* mini ball arc to the cart icon (820 ms); returns landing time */
  function fly(src) {
    var cart = doc.getElementById('ss-cart-btn');
    if (!src || SS.reduced || !src.getBoundingClientRect || !cart || !cart.getClientRects().length) return 0;
    try {
      var f = src.getBoundingClientRect(), to = cart.getBoundingClientRect();
      if (!f.width) return 0;
      var x0 = f.left + f.width / 2, y0 = f.top + f.height / 2, x1 = to.left + to.width / 2, y1 = to.top + to.height / 2;
      var dot = doc.body.appendChild(doc.createElement('div'));
      dot.className = 'fly';
      if (!dot.animate) { dot.remove(); return 0; }
      var tr = function (x, y, k, r) { return 'translate(' + x + 'px,' + y + 'px) scale(' + k + ') rotate(' + r + 'deg)'; };
      dot.animate([
        { transform: tr(x0, y0, 0.6, 0), opacity: 0 },
        { transform: tr(x0, y0 - 20, 1, 60), opacity: 1, offset: 0.12 },
        { transform: tr((x0 + x1) / 2, Math.min(y0, y1) - 160, 1.35, 320), offset: 0.55 },
        { transform: tr(x1, y1, 0.35, 660), opacity: 1 }
      ], { duration: 820, easing: 'cubic-bezier(.45,0,.25,1)' }).onfinish = function () { dot.remove(); };
      return Date.now() + 820;
    } catch (e) { return 0; }
  }
  function setBusy(el, on) {
    if (!el) return;
    if (on) { el.setAttribute('aria-busy', 'true'); el.__ssDis = el.disabled; el.disabled = true; }
    else { el.removeAttribute('aria-busy'); el.disabled = !!el.__ssDis; }
  }
  /* .done for 1.8 s; label swap on .pc-add > span or [data-added-label] + [data-label] */
  function markDone(src) {
    if (!src || !src.classList) return;
    src.classList.add('done');
    var t = null, text = src.getAttribute('data-added-label') || SS.str('added', 'Added');
    if (src.hasAttribute('data-added-label')) t = src.querySelector('[data-label]');
    else if (src.classList.contains('pc-add')) {
      for (var i = src.children.length - 1; i >= 0 && !t; i--) {
        if (src.children[i].tagName === 'SPAN' && !src.children[i].classList.contains('sr')) t = src.children[i];
      }
    }
    if (t) { if (t.__ssOrig == null) t.__ssOrig = t.textContent; t.textContent = text; }
    clearTimeout(src.__ssDoneT);
    src.__ssDoneT = setTimeout(function () {
      src.classList.remove('done');
      if (t && t.__ssOrig != null) { t.textContent = t.__ssOrig; t.__ssOrig = null; }
    }, 1800);
  }
  function fail(err, src) {
    var msg = (err && err.description) || SS.str('error');
    SS.toast(msg);
    SS.emit('cart:error', { message: msg, source: src });
  }

  function add(o) {
    o = o || {};
    var src = o.source || null, body = o.form ? new FormData(o.form) : new FormData();
    if (!o.form) { body.append('id', o.id); body.append('quantity', o.quantity || 1); }
    else if (o.quantity) body.set('quantity', o.quantity);
    var vid = String(body.get('id') || o.id || '');
    body.append('sections', ids().join(','));
    body.append('sections_url', location.pathname);
    SS.emit('cart:add:start', { source: src });
    var land = fly(src), dr0 = drawer(), fromDrawer = !!(src && dr0 && !dr0.hidden && dr0.contains(src));
    setBusy(src, true);
    busy++;
    return SS.fetchJSON(addUrl, { method: 'POST', body: body }).then(function (res) {
      return SS.fetchJSON(cartJs).then(function (cart) {
        setBusy(src, false);
        apply(res && res.sections);
        markDone(src);
        open({ trigger: src });
        setTimeout(bump, Math.max(0, land - Date.now()));
        setTimeout(function () { flash(vid, fromDrawer); }, 120);
        SS.emit('cart:updated', { cart: cart, source: src, addedVariantId: vid, action: 'add' });
        return cart;
      });
    }).catch(function (err) {
      setBusy(src, false);
      fail(err, src);
      throw err;
    }).finally(function () { busy--; });
  }

  function change(key, qty, src) {
    var box = src && src.closest ? src.closest('[data-qty]') : null;
    if (box) box.setAttribute('aria-busy', 'true');
    busy++;
    return SS.fetchJSON(changeUrl, { method: 'POST', body: { id: key, quantity: qty, sections: ids(), sections_url: location.pathname } })
      .then(function (cart) {
        apply(cart && cart.sections);
        SS.emit('cart:updated', { cart: cart, source: src || null, action: 'change' });
        return cart;
      })
      .catch(function (err) {
        if (box) box.removeAttribute('aria-busy');
        fail(err, src);
        return refresh();
      })
      .finally(function () { busy--; });
  }

  function refresh() {
    return SS.fetchJSON(location.pathname + '?sections=' + encodeURIComponent(ids().join(','))).then(function (sections) {
      apply(sections);
      return SS.fetchJSON(cartJs);
    }).then(function (cart) {
      SS.emit('cart:updated', { cart: cart, source: null, action: 'change' });
      return cart;
    }).catch(function () { return null; });
  }

  function open(o) {
    if (!drawer()) { location.href = R.cart || '/cart'; return; }
    SS.overlay.open(DR, { trigger: (o || {}).trigger });
    syncBody();
  }
  function close() { SS.overlay.close(DR); }

  SS.cart = { add: add, change: change, refresh: refresh, open: open, close: close, busy: function () { return busy > 0; } };
  SS.on('overlay:close', function (d) { if (d.id === DR && d.el) d.el.removeAttribute('data-still'); });

  function queue(box, qty, src) {
    var key = box.getAttribute('data-line-key');
    clearTimeout(pend[key]);
    pend[key] = setTimeout(function () { delete pend[key]; change(key, qty, src); }, 320);
  }
  doc.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var el = t.closest('[data-open-drawer]');
    if (el && drawer()) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      open({ trigger: el });
      return;
    }
    if ((el = t.closest('[data-add-to-cart]'))) {
      e.preventDefault();
      if (el.disabled || el.getAttribute('aria-busy') === 'true') return;
      add({ id: el.getAttribute('data-variant-id'), quantity: Number(el.getAttribute('data-qty')) || 1, source: el }).catch(function () {});
      return;
    }
    if ((el = t.closest('[data-line-remove]'))) {
      e.preventDefault();
      change(el.getAttribute('data-line-key'), 0, el);
      return;
    }
    var step = t.closest('[data-qty-step]'), box = step && step.closest('[data-qty][data-line-key]');
    if (!box) return;
    e.preventDefault();
    var input = box.querySelector('.qty-in');
    if (!input) return;
    var next = Math.max(1, Math.min(Number(input.max) || 99, (Number(input.value) || 0) + Number(step.getAttribute('data-qty-step'))));
    if (String(next) === input.value) return;
    input.value = next;
    queue(box, next, step);
  });
  doc.addEventListener('change', function (e) {
    var input = e.target, box = input.classList && input.classList.contains('qty-in') && input.closest('[data-qty][data-line-key]');
    if (!box) return;
    var v = Math.round(Number(input.value));
    if (isNaN(v)) return;
    input.value = v = Math.max(0, Math.min(Number(input.max) || 99, v));
    queue(box, v, input);
  });
  doc.addEventListener('keydown', function (e) {
    var i = e.target;
    if (e.key === 'Enter' && i.matches && i.matches('[data-line-key] .qty-in')) { e.preventDefault(); i.dispatchEvent(new Event('change', { bubbles: true })); }
  });
  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-product-form]') || !window.fetch || !window.FormData || !window.DOMParser) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn && btn.getAttribute('aria-busy') === 'true') return;
    add({ form: form, source: btn }).catch(function () {});
  });

  /* theme editor: show the drawer while its section is selected */
  var mine = function (e) { return e.target.querySelector && e.target.querySelector('#' + DR); };
  doc.addEventListener('shopify:section:select', function (e) { if (mine(e)) open(); });
  doc.addEventListener('shopify:section:deselect', function (e) { if (mine(e)) close(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  window.addEventListener('resize', syncBody, { passive: true });
})();
